import React, {ReactElement} from 'react';
import './index.scss';

type AccordionMenuProps = {
  title: string;
  children: JSX.Element | JSX.Element[];
};

const AccordionMenu: React.FC<AccordionMenuProps> = ({
  title,
  children
}: AccordionMenuProps): ReactElement => {
  return (
    <div className="accordionMenu">
      <div className="accordionMenuTitle">
        <h3>{title}</h3>
      </div>
      {children}
    </div>
  );
};

export default AccordionMenu;
